<template>
  <q-card-actions align="center">
    <q-btn no-caps class="btn-brand" @click="onHistoricData"
      >Historic Data</q-btn
    >
  </q-card-actions>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ViewerDeviceActions',
  methods: {
    onHistoricData() {},
  },
});
</script>

<style scoped></style>
